<script setup lang="ts">
import { useLocalePath } from '@/composables/useLocalePath';
import { LOCALE_META, SUPPORTED_LOCALES } from '@/i18n/locales';

const { locale, switchLocalePath } = useLocalePath();
</script>

<template>
  <div class="lang-switcher">
    <!-- Plain anchors rather than RouterLink: these are the `rel=alternate`
         hreflang pairs for the current page, so crawlers should see real hrefs,
         and vue-router still intercepts the click. -->
    <RouterLink
      v-for="code in SUPPORTED_LOCALES"
      :key="code"
      rel="alternate"
      :hreflang="code"
      :to="switchLocalePath(code)"
      class="lang"
      :class="{ active: locale === code }"
    >
      <span class="text">{{ LOCALE_META[code].shortLabel }}</span>
    </RouterLink>
  </div>
</template>
